var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h2',{staticClass:"mx-3 mt-4 mb-0 rounded-container-h2 text-muted"},[_vm._t("title")],2),_c('div',{staticClass:"rounded_wrap m-2",class:_vm.containerStyle},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }